(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scatter-marquee-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const DESIGN_W = 1656, DESIGN_H = 1120;

  function initInstance(root){
    if (root.dataset.smInitialized === 'true') return;
    root.dataset.smInitialized = 'true';

    const stage = root.querySelector('[data-sm-stage]');
    const row   = root.querySelector('[data-sm-row]');
    const copy  = root.querySelector('[data-sm-copy]');
    const thumbEls = Array.from(root.querySelectorAll('[data-sm-thumb]'));
    if (!stage || !row || thumbEls.length === 0) return;

    let cleanupFns = [];

    // Full-bleed width is handled purely in CSS via the `.force-full-width`
    // utility class (see the theme's page-width grid in base.css), the same
    // mechanism other full-width sections use. Previously this was done by
    // measuring window.innerWidth in JS and applying a negative margin,
    // which could drift from the actual layout viewport on some mobile
    // browsers and made the whole page horizontally scrollable — so that
    // approach has been removed in favor of the CSS-only breakout.

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const animationEnabled = root.dataset.animationEnabled !== 'false';

    const slotH   = parseInt(root.dataset.rowHeight, 10) || 190;
    const gap     = parseInt(root.dataset.imageGap, 10) || 28;
    const topPad  = parseInt(root.dataset.topPadding, 10) || 56;
    const bottomPad = 40;
    const pxPerSecond = parseInt(root.dataset.marqueeSpeed, 10) || 26;
    const slotW = 148;

    const thumbs = thumbEls.map((el) => ({
      el,
      top:  (parseFloat(el.dataset.y) / DESIGN_H) * 100,
      left: (parseFloat(el.dataset.x) / DESIGN_W) * 100,
      w:    (parseFloat(el.dataset.w) / DESIGN_W) * 100,
      h:    (parseFloat(el.dataset.h) / DESIGN_H) * 100,
    }));

    if (!animationEnabled || reduceMotion) {
      // Static fallback: skip straight to the settled state, no timers.
      thumbEls.forEach(el => el.classList.add('is-visible'));
      if (copy) copy.classList.add('is-visible');
      root.classList.add('sm-no-js');
      return () => { cleanupFns.forEach(fn => fn()); };
    }

    // Place thumbs at scatter positions.
    thumbs.forEach(t => {
      t.el.style.top = t.top + '%';
      t.el.style.left = t.left + '%';
      t.el.style.width = t.w + '%';
      t.el.style.height = t.h + '%';
    });

    function fadeInAsync(){
      return Promise.all(thumbs.map((t, i) => new Promise(resolve => {
        const media = t.el.querySelector('img, video');
        const reveal = () => {
          const delay = (i * 55) + Math.random() * 220;
          const id = setTimeout(() => { t.el.classList.add('is-visible'); resolve(); }, delay);
          cleanupFns.push(() => clearTimeout(id));
        };
        if (!media) { reveal(); return; }
        if (media.tagName === 'VIDEO') {
          if (media.readyState >= 2) reveal();
          else {
            media.addEventListener('loadeddata', reveal, { once: true });
            media.addEventListener('error', reveal, { once: true });
          }
        } else {
          if (media.complete) reveal();
          else {
            media.addEventListener('load', reveal, { once: true });
            media.addEventListener('error', reveal, { once: true });
          }
        }
      })));
    }

    function convergeToRow(){
      const stageBox = stage.getBoundingClientRect();
      const spacing = slotW + gap;
      const rowWidth = thumbs.length * spacing - gap;
      const startX = (stageBox.width - rowWidth) / 2;

      thumbs.forEach((t, i) => {
        t.el.style.left = (startX + i * spacing) + 'px';
        t.el.style.top = topPad + 'px';
        t.el.style.width = slotW + 'px';
        t.el.style.height = slotH + 'px';
      });

      return { rowWidth, spacing };
    }

    function collapseStage(){
      stage.style.height = (slotH + topPad + bottomPad) + 'px';
    }

    function startMarquee(layout){
      const period = layout.spacing * thumbs.length;
      thumbs.forEach((t, i) => {
        const clone = t.el.cloneNode(true);
        clone.classList.add('is-visible');
        clone.style.left = (parseFloat(t.el.style.left) + period) + 'px';
        clone.style.top = topPad + 'px';
        clone.style.width = slotW + 'px';
        clone.style.height = slotH + 'px';
        clone.style.transition = 'none';
        row.appendChild(clone);
        // Cloned <video> elements don't reliably resume autoplay on their
        // own in every browser, so nudge them explicitly.
        const clonedVideo = clone.querySelector('video');
        if (clonedVideo) {
          clonedVideo.muted = true;
          const playPromise = clonedVideo.play();
          if (playPromise && playPromise.catch) playPromise.catch(() => {});
        }
      });

      row.style.setProperty('--sm-marquee-distance', `-${period}px`);
      row.style.animationDuration = (period / pxPerSecond) + 's';

      requestAnimationFrame(() => row.classList.add('is-marquee'));
    }

    fadeInAsync().then(() => {
      const t1 = setTimeout(() => {
        const layout = convergeToRow();
        // Reveal the heading/CTA as soon as the photos have finished
        // gliding into their single row — don't make copy wait for the
        // stage collapse + marquee start too.
        const t1b = setTimeout(() => {
          if (copy) copy.classList.add('is-visible');
        }, 1150);
        cleanupFns.push(() => clearTimeout(t1b));
        const t2 = setTimeout(() => {
          collapseStage();
          const t3 = setTimeout(() => {
            startMarquee(layout);
          }, 1150);
          cleanupFns.push(() => clearTimeout(t3));
        }, 1150);
        cleanupFns.push(() => clearTimeout(t2));
      }, 750);
      cleanupFns.push(() => clearTimeout(t1));
    });

    return () => { cleanupFns.forEach(fn => fn()); };
  }

  function initAll(){
    document.querySelectorAll('[data-scatter-marquee]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init a section when it's added/re-rendered, and tear
  // down cleanly when it's removed, so live editing never stacks up
  // duplicate timers or marquee animations.
  const cleanupByRoot = new WeakMap();

  document.addEventListener('shopify:section:load', (event) => {
    // Shopify re-renders the section's markup from scratch on every settings
    // change, so this is always a fresh element with no prior state on it.
    const root = event.target.querySelector('[data-scatter-marquee]');
    if (!root) return;
    const cleanup = initInstance(root);
    if (cleanup) cleanupByRoot.set(root, cleanup);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-scatter-marquee]');
    if (!root) return;
    const cleanup = cleanupByRoot.get(root);
    if (cleanup) cleanup();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
